<script setup>
import { computed } from 'vue';

const props = defineProps({
  headers: {
    type: Array,
    default: () => [],
  },
  items: {
    type: Array,
    default: () => [],
  },
  noDataMessage: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const hasHeaderSlot = computed(() => !!props.headers.length);
const showHeaders = computed(
  () => hasHeaderSlot.value && props.items.length > 0
);
</script>

<template>
  <div
    class="chatmigo-elevated-card w-full overflow-hidden rounded-lg border border-n-container"
  >
    <table
      class="min-w-full table-auto divide-y divide-n-weak [&_tbody_tr]:transition-colors [&_tbody_tr:hover]:bg-n-alpha-1"
    >
      <thead
        v-if="showHeaders"
        class="chatmigo-section-header border-b border-n-weak"
      >
        <tr>
          <th
            v-for="(header, index) in headers"
            :key="index"
            class="px-4 py-3.5 text-start text-xs font-semibold uppercase tracking-[0.12em] text-n-slate-11 first:ltr:pl-6 first:rtl:pr-6 last:ltr:pr-6 last:rtl:pl-6"
          >
            <slot :name="`header-${index}`" :header="header">
              {{ header }}
            </slot>
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-n-weak bg-transparent text-n-slate-11">
        <template v-if="items.length">
          <slot name="row" :items="items" />
        </template>
        <tr v-else-if="noDataMessage && !loading">
          <td
            :colspan="headers.length || 1"
            class="px-6 py-20 text-center text-body-main !text-base text-n-slate-11"
          >
            {{ noDataMessage }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
